import { useCallback } from 'react';
import React from 'react';

import type { CampaignInfoV2, CampaignSearchResponseV2 } from '~/api/v2/mall/campaign/search';
import type { CommonDataResponseV2 } from '~/api/v2/mall/common-data';
import type { SegmentResponseV2 } from '~/api/v2/mall/segment';
import { DATA_AREAS } from '~/constants/data-areas';
import { CampaignCard } from '~/ui/campaign-card';

import { campaignCardStyles } from '../styles';
import { SitePoint } from './point/site-point';

export const SiteShopRanking = ({
  commonData,
  campaignSearch,
  segment: _segment, // NOTE: segmentは将来的にポイント表示のパーソナライゼーションに使用予定
}: {
  commonData: CommonDataResponseV2;
  campaignSearch: CampaignSearchResponseV2;
  segment?: Promise<SegmentResponseV2>;
}) => {
  if (!commonData) return null;
  if (!campaignSearch) return null;

  const renderPoint = useCallback((campaign: CampaignInfoV2) => <SitePoint data={campaign} size="small" />, []);

  return (
    <div className="grid grid-cols-2 gap-2 md:grid-cols-5 lg:gap-4" data-area={DATA_AREAS.SITE_SHOP_RANKING}>
      {campaignSearch.campaign_info.map((campaign) => {
        const isPointup = campaign.net.advertisement.some((item) => item.pointup_flg);
        const card = (
          <CampaignCard campaignInfo={campaign} styles={campaignCardStyles} renderPoint={() => renderPoint(campaign)}>
            <div className="text-caption-s row-[3/4] line-clamp-1 min-h-8 text-center">
              {campaign.achievement_point_id && Number(campaign.achievement_point_id) > 0 && (
                <>{commonData.achievement_point[campaign.achievement_point_id]?.name}</>
              )}
            </div>
          </CampaignCard>
        );
        if (isPointup) {
          return (
            <div
              key={campaign.campaign_id}
              className="pointup-wrap [&>div]:border-brand relative [&>div]:border-1 [&>div]:border-solid">
              <p className="text-caption-s-bold bg-brand absolute top-[1px] left-0 w-full rounded-t-sm text-center text-white">
                株引換券還元率UP中！
              </p>
              {card}
            </div>
          );
        } else {
          return <React.Fragment key={campaign.campaign_id}>{card}</React.Fragment>;
        }
      })}
    </div>
  );
};
